import { createApp } from 'vue';
import App from './App.vue';
import './styles.css';

// Wait for Office.js to finish initializing before mounting the Vue app — Word.run
// helpers are unavailable until Office.onReady resolves.
Office.onReady((info) => {
  if (info.host !== Office.HostType.Word) {
    // Refuse to mount outside Word; the manifest limits us to Word but a stray sideload
    // on a wrong host should fail loudly, not silently render nothing.
    document.getElementById('app')!.textContent = 'This add-in only runs inside Microsoft Word.';
    return;
  }
  createApp(App).mount('#app');
});
